import { useEffect, useState } from "react";
import { toast } from "sonner";
import { admin } from "../../lib/api";
import { slugify } from "../../lib/format";
import { panel, inputCls, btnPrimary, btnGhost, Field, PageHead } from "../ui";
import { Trash2, Pencil } from "lucide-react";

const STATUSES = ["draft", "scheduled", "live", "archived", "hidden"];
const blank = { name: "", short_description: "", long_description: "", status: "live", cover_image: "", banner_image: "", launch_date: "" };

export default function Collections() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(blank);
  const [editing, setEditing] = useState(null);

  const load = () => admin.get("/admin/collections").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.name) return;
    const body = { ...form, slug: form.slug || slugify(form.name) };
    if (editing) await admin.put(`/admin/collections/${editing}`, body);
    else await admin.post("/admin/collections", body);
    setForm(blank); setEditing(null); toast.success("Saved"); load();
  };
  const edit = (c) => { setEditing(c.id); setForm({ ...blank, ...c }); window.scrollTo(0, 0); };
  const del = async (c) => { if (!window.confirm(`Delete ${c.name}?`)) return; await admin.delete(`/admin/collections/${c.id}`); load(); };

  return (
    <div>
      <PageHead title="Collections" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        <div className={`${panel} p-5 space-y-3 h-fit`}>
          <p className="text-sm font-semibold text-white uppercase tracking-wider">{editing ? "Edit" : "Add"} Collection</p>
          <Field label="Name"><input className={inputCls} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="collection-name" /></Field>
          <Field label="Status">
            <select className={inputCls} value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
              {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </Field>
          {form.status === "scheduled" && <Field label="Launch date"><input type="datetime-local" className={inputCls} value={(form.launch_date || "").slice(0, 16)} onChange={(e) => setForm({ ...form, launch_date: new Date(e.target.value).toISOString() })} /></Field>}
          <Field label="Short description"><input className={inputCls} value={form.short_description} onChange={(e) => setForm({ ...form, short_description: e.target.value })} /></Field>
          <Field label="Long description"><textarea rows={3} className={inputCls} value={form.long_description} onChange={(e) => setForm({ ...form, long_description: e.target.value })} /></Field>
          <Field label="Cover image URL"><input className={inputCls} value={form.cover_image} onChange={(e) => setForm({ ...form, cover_image: e.target.value, banner_image: e.target.value })} /></Field>
          <div className="flex gap-2">
            <button onClick={save} className={btnPrimary} data-testid="collection-save-btn">Save</button>
            {editing && <button onClick={() => { setEditing(null); setForm(blank); }} className={btnGhost}>Cancel</button>}
          </div>
        </div>

        <div className={`${panel} p-5 lg:col-span-2`}>
          <div className="space-y-2">
            {list.map((c) => (
              <div key={c.id} className="flex items-center gap-3 py-2 border-b border-zinc-900">
                <img src={c.cover_image} alt="" className="w-12 h-12 object-cover bg-zinc-900" />
                <div className="flex-1"><p className="text-sm text-zinc-100">{c.name}</p><p className="text-[11px] text-zinc-600">{c.effective_status || c.status}</p></div>
                <button onClick={() => edit(c)} className="text-zinc-400 hover:text-white"><Pencil size={15} /></button>
                <button onClick={() => del(c)} className="text-zinc-400 hover:text-red-400"><Trash2 size={15} /></button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
